import { settingsPosTrackingMethodLocationsPath } from '../../../../routes/Paths';

export const NAV_KEYS = {
  POS_TRACKING_METHOD_LOCATIONS: 'pos-tracking-method-locations'
};

export const navKeysByPath = {
  [settingsPosTrackingMethodLocationsPath]:
    NAV_KEYS.POS_TRACKING_METHOD_LOCATIONS
};
